import PropTypes from 'prop-types';
import React from 'react';
import { useSelector } from 'react-redux';

import Alert from '@mui/material/Alert';
import InputField from './InputField';

import './LoginPage.scss';

const NEW_PASSWORD_REQUIRED = 'NEW_PASSWORD_REQUIRED';
const SMS_MFA = 'SMS_MFA';
const FIREBASE_MFA_CODE = 'FIREBASE_MFA_CODE';
const FIREBASE_MFA_CHOOSE_FACTOR = 'FIREBASE_MFA_CHOOSE_FACTOR';
export default function SignIn(props, context) {
  const [error, setError] = React.useState(null);
  const [email, setEmail] = React.useState('');
  const [loginMode, setLoginMode] = React.useState('email');
  const [orgCode, setOrgCode] = React.useState('');
  const [password, setPassword] = React.useState('');
  const currentLang = useSelector((state) => state.i18nState.lang) || 'en';
  const isHebrew = currentLang === 'he' || currentLang === 'hebrew';

  function handleInputChange(setter) {
    return (event) => {
      setter(event.target.value);
    };
  }

  function doSignIn() {
    setError(null);
    props.setLoading(true);
    props.signInFunc(email, password, (data) => {
      props.setLoading(false);

      if (data instanceof Error) {
        setError(data);
      } else if (data.challengeName === NEW_PASSWORD_REQUIRED) {
        props.changeLoginMode('newPasswordRequired', { email, password });
      } else if (data.challengeName === SMS_MFA) {
        props.setLoggingInUser(data);
        props.changeLoginMode('setMfaCode');
      } else if (data.challengeName === FIREBASE_MFA_CODE) {
        props.changeLoginMode('setFirebaseMfaCode');
      } else if (data.challengeName === FIREBASE_MFA_CHOOSE_FACTOR) {
        props.changeLoginMode('chooseMfaFactor', {
          hints: data.hints,
          session: data.session,
        });
      }
    });
  }

  const doSignInSSO = async () => {
    setError(null);
    try {
      props.setLoading(true);
      await props.signInSSO(orgCode);
    } catch (error) {
      setError(error);
    } finally {
      props.setLoading(false);
    }
  }

  return (
    <div style={{ margin: '50px 30px' }}>
      {error && (
        <Alert
          style={{ position: 'absolute', top: '-35%', fontSize: 'large' }}
          severity='error'
        >
          {error.message}
        </Alert>
      )}

      {process.env.REACT_APP_SYSTEM === 'STAGE' &&
        <div className='container-login-mode'>
          <button className='btn-login-mode'
            style={{ backgroundColor: loginMode === 'email' ? '#b6b6b6' : 'transparent' }}
            onClick={() => setLoginMode('email')}
          >User Name</button>
          <button className='btn-login-mode'
            style={{ backgroundColor: loginMode === 'orgCode' ? '#b6b6b6' : 'transparent' }}
            onClick={() => setLoginMode('orgCode')}
          >Org Code</button>
        </div>}

      {loginMode === 'email' ? (
        <SignInEmailPassword
          handleInputChange={handleInputChange}
          email={email}
          password={password}
          setEmail={setEmail}
          setPassword={setPassword}
          isHebrew={isHebrew}
          doSignIn={doSignIn}
          loading={props.loading}
        />
      ) : (
        <SignInOrgCode
          handleInputChange={handleInputChange}
          orgCode={orgCode}
          setOrgCode={setOrgCode}
          isHebrew={isHebrew}
          doSignInSSO={doSignInSSO}
          loading={props.loading}
        />
      )}

    </div>
  );
}

SignIn.contextTypes = {
  t: PropTypes.func.isRequired,
};

SignIn.propTypes = {
  changeLoginMode: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  setLoading: PropTypes.func.isRequired,
  setLoggingInUser: PropTypes.func.isRequired,
  signInFunc: PropTypes.func.isRequired,
};

const SignInEmailPassword = ({ handleInputChange, email, password, setEmail, setPassword, isHebrew, doSignIn, loading }, context) => {
  return (
    <>
      <InputField
        label={context.t('email')}
        labelStyle={
          isHebrew ? { textAlign: 'right', direction: 'rtl' } : undefined
        }
        name='email'
        type='email'
        value={email}
        onChange={handleInputChange(setEmail)}
        disabled={loading}
      />
      <InputField
        label={context.t('password')}
        labelStyle={
          isHebrew ? { textAlign: 'right', direction: 'rtl' } : undefined
        }
        name='password'
        type='password'
        value={password}
        onChange={handleInputChange(setPassword)}
        disabled={loading}
      />
      <a
        className='forgot-link'
        onClick={() => changeLoginMode('resetPassword')}
        href='#'
      >
        {context.t('forgot_password')}
      </a>

      <div className='form-group form-actions'>
        <div className='col-xs-6 col-xs-offset-3 login-field'>
          <button
            className='login-submit btn btn-success btn-block'
            type='submit'
            onClick={doSignIn}
          >
            {context.t('login')}
          </button>
        </div>
      </div>
    </>
  )
}

SignInEmailPassword.contextTypes = {
  t: PropTypes.func.isRequired,
};

const SignInOrgCode = ({ handleInputChange, orgCode, setOrgCode, isHebrew, doSignInSSO, loading }, context) => {
  return (
    <>
      <InputField
        label={context.t('orgCode')}
        labelStyle={
          isHebrew ? { textAlign: 'right', direction: 'rtl' } : undefined
        }
        name='orgCode'
        type='text'
        value={orgCode}
        onChange={handleInputChange(setOrgCode)}
        disabled={loading}
      />

      <div className='form-group form-actions'>
        <div className='col-xs-6 col-xs-offset-3 login-field'>
          <button
            className='login-submit btn btn-success btn-block'
            onClick={doSignInSSO}
            disabled={loading || !orgCode}
          >SSO</button>
        </div>
      </div>
    </>
  )
}

SignInOrgCode.contextTypes = {
  t: PropTypes.func.isRequired,
};
